module.exports = __webpack_public_path__ + "static/img/user-04.ebf19a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-04.png
// module id = Y6jS
// module chunks = 1